module.exports = __webpack_public_path__ + "static/media/service9.5b26f551.jpg";